import React, { useEffect, useState } from 'react';
import Proptypes from 'prop-types';

import { Title, Input, DropdownFilter } from '@fnacdarty/back-office-ui';
import ActivityItem from '../ActivityItem';
import ActivitySort from '../ActivitySort';
import ActivitySkeleton from '../ActivitySkeleton';

import { filterActivities } from '../../utils/activity';

import {
	StyledContainerList,
	StyledActivityList,
	StyledHeader,
	StyledError,
	DivError,
	SpanError,
	StyledSearchIcon,
} from './index.styled';

const ActivityList = ({
	activities,
	filters,
	setFilters,
	selectedActivity,
	setSelectedActivity,
	updateActivity,
	isVersionPC,
	updateSearch,
}) => {
	const [status] = useState({
		loading: false,
		error: '',
	});
	window.history.pushState({}, '', '/activities');

	const [filteredActivities, setFilteredActivities] = useState({
		activities,
		inititialized: false,
	});

	// Determine the activity for Scrolling
	let now = new Date();
	const d = now.getDate();
	const m = now.getMonth() + 1;
	const y = now.getFullYear();
	now = `${y}-${m < 10 ? `0${m}` : m}-${d < 10 ? `0${d}` : d}`;
	const tsNow = new Date(now).getTime();

	let refActivityId = null;
	if (activities !== null) {
		activities.forEach((activity) => {
			const dt = new Date(activity.date);
			const tsActivity = dt.getTime();

			if (refActivityId === null && tsActivity > tsNow) {
				refActivityId = activity.id;
			}
		});
	}
	// filter the list by resources and treatments
	useEffect(() => {
		// timeout to improve the user experience
		const timeout = setTimeout(() => {
			if (activities && activities?.length > 0) {
				const operatedActivities = activities.filter((activity) =>
					filterActivities(activity, filters),
				);

				// sort the list by filters.sort
				// get path to sort filter.sort.path
				if (!filters.sort?.by?.path) {
					return setFilteredActivities({
						activities: operatedActivities,
						inititialized: true,
					});
				}
				const path = filters.sort.by.path.split('.');
				// sort the list
				operatedActivities.sort((a, b) => {
					// get the value of the path
					const valueA = path.reduce((acc, curr) => acc[curr], a);
					const valueB = path.reduce((acc, curr) => acc[curr], b);
					// sort the list compare to the type of the value and the order of the sort
					if (filters.sort.by.type === 'string') {
						if (filters.sort.order === 'asc')
							return valueA.localeCompare(valueB);
						return valueB.localeCompare(valueA);
					}
					if (filters.sort.by.type === 'date') {
						if (filters.sort.order === 'asc')
							return new Date(valueA) - new Date(valueB);
						return new Date(valueB) - new Date(valueA);
					}
					if (filters.sort.by.type === 'number') {
						if (filters.sort.order === 'asc')
							return valueA - valueB;
						return valueB - valueA;
					}
					if (filters.sort.by.type === 'boolean') {
						if (filters.sort.order === 'asc') return valueA;
						return valueB;
					}
					return 0;
				});

				return setFilteredActivities({
					activities: operatedActivities,
					inititialized: true,
				});
			}
			if (!activities) {
				return setFilteredActivities({
					activities: [],
					inititialized: false,
				});
			}
			return setFilteredActivities({
				activities: [],
				inititialized: true,
			});
		}, 500);

		return () => clearTimeout(timeout);
	}, [activities, filters]);
	const sortedRessources = filters.resources.sort((a, b) => {
		if (a.name < b.name) {
			return -1;
		}
		if (a.name > b.name) {
			return 1;
		}
		return 0;
	});
	const updateResources = (newResources) => {
		setFilters({
			...filters,
			resources: newResources,
		});
	};

	let level = 3;
	if (!isVersionPC()) {
		level = 4;
	}

	return (
		<StyledContainerList>
			{isVersionPC() && (
				<StyledHeader>
					<Title level={2}>Liste des activités</Title>
					<ActivitySort filters={filters} setFilters={setFilters} />
				</StyledHeader>
			)}
			{!isVersionPC() && (
				<StyledHeader>
					<Input
						placeholder="Rechercher..."
						type="text"
						value={filters.search}
						onChange={updateSearch}
						style={{ height: '28px', marginRight: '5px' }}
						className="search"
					/>
					<StyledSearchIcon name="search" width="20px" />

					<DropdownFilter
						title=""
						identifier="name"
						label="name"
						options={sortedRessources}
						setOptions={updateResources}
						multiSelect={true}
						extraActions={null}
						showIcon={true}
						icon="menu"
					/>
				</StyledHeader>
			)}
			<div style={{ textAlign: 'center' }}>
				{status.error ? (
					<StyledError className="error">{status.error}</StyledError>
				) : null}
			</div>

			{activities && activities?.length === 0 && (
				<DivError>
					<SpanError>Aucune activité à afficher</SpanError>
				</DivError>
			)}

			{(!activities ||
				(filteredActivities?.activities?.length === 0 &&
					!filteredActivities.inititialized)) && <ActivitySkeleton />}

			{activities && activities?.length > 0 && (
				<StyledActivityList>
					{filteredActivities?.activities?.length > 0
						? filteredActivities?.activities.map(
								(activity, index) => (
									<ActivityItem
										key={index}
										selectedActivity={selectedActivity}
										setSelectedActivity={
											setSelectedActivity
										}
										activity={activity}
										updateActivity={updateActivity}
										isVersionPC={isVersionPC}
										refActivityId={refActivityId}
									/>
								),
						  )
						: activities &&
						  activities?.length > 0 &&
						  filteredActivities.inititialized && (
								<StyledError>
									<Title level={level}>
										Aucune activité ne correspond à votre
										recherche
									</Title>
								</StyledError>
						  )}
				</StyledActivityList>
			)}
		</StyledContainerList>
	);
};

ActivityList.propTypes = {
	activities: Proptypes.array,
	filters: Proptypes.object,
	setFilters: Proptypes.func,
	selectedActivity: Proptypes.object,
	setSelectedActivity: Proptypes.func,
	updateActivity: Proptypes.func,
	isVersionPC: Proptypes.func,
	updateSearch: Proptypes.func.isRequired,
};

export default ActivityList;
